import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TrackState } from '../_models/TrackState';

@Injectable()
export class AudioPlayerService {

  private playTrackSource = new Subject<string>();
  private pauseTrackSource = new Subject();
  private trackEndedSource = new Subject();
  private timeUpdateSource = new Subject<TrackState>();
  private currentTimeChangedSource = new Subject();

  playTrack$ = this.playTrackSource.asObservable();
  pauseTrack$ = this.pauseTrackSource.asObservable();
  trackEnded$ = this.trackEndedSource.asObservable();
  timeUpdate$ = this.timeUpdateSource.asObservable();
  currentTimeChanged$ = this.currentTimeChangedSource.asObservable();

  playTrack(url: string) {
    this.playTrackSource.next(url);
  }

  pauseTrack() {
    this.pauseTrackSource.next();
  }

  trackEnded() {
    this.trackEndedSource.next();
  }

  timeUpdate(state: TrackState) {
    this.timeUpdateSource.next(state);
  }

  currentTimeUpdate(time: number) {
    this.currentTimeChangedSource.next(time);
  }
}
